import React, {useEffect} from "react";
import {PublisherDetails} from "../../components/publisher/details";
import {useDispatch} from "react-redux";
import {toggleLoader} from "../../store/global/global-slice";
import {PublisherService} from "../../services/publisher.service";
import {PublisherModel} from "../../models/publisher.model";
import {DetailsWrapper} from "../../components/details-wrapper/details-wrapper";
import {useTranslation} from "react-i18next";

const PublisherProfilePage = () => {
    const [publisher, setPublisher] = React.useState<PublisherModel>(null);
    const dispatch = useDispatch();
    const { t } = useTranslation('publisher');

    useEffect(() => {
        const loadProfile = async () => {
            dispatch(toggleLoader(true));
            const profile = await PublisherService.getMe();

            if (profile) {
                setPublisher(profile);

                dispatch(toggleLoader(false));
            }
        }

        loadProfile();
    }, [dispatch]);

    return (
        <DetailsWrapper description={t('profile.pageDesc')}>
            {publisher &&
                <PublisherDetails publisher={publisher}/>
            }
        </DetailsWrapper>
    )
}

export default PublisherProfilePage;
